module.exports = __webpack_public_path__ + "static/media/p_19_4.dd5493fc.png";